import React, { useEffect, useState } from 'react';
import { LaunchNav } from '../components/hospitality-launch/LaunchNav';
import { HospitalityHero } from '../components/hospitality-launch/HospitalityHero';
import { PlatformOverview } from '../components/hospitality-launch/PlatformOverview';
import { LiveFloorPreview } from '../components/hospitality-launch/LiveFloorPreview';
import { AgentShowcase } from '../components/hospitality-launch/AgentShowcase';
import { AijentikBrain } from '../components/hospitality-launch/AijentikBrain';
import { EOIForm } from '../components/hospitality-launch/EOIForm';
import { FinalCTA } from '../components/hospitality-launch/FinalCTA';
import { motion, AnimatePresence } from 'framer-motion';
export function HospitalityLaunch() {
  const [showMobileCTA, setShowMobileCTA] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => {
      // Show sticky mobile CTA after scrolling past hero
      setShowMobileCTA(window.scrollY > window.innerHeight);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToEOI = () => {
    const element = document.getElementById('eoi-form');
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <main className="bg-brand-black min-h-screen selection:bg-brand-orange/30 font-body" data-id="element-1071">
      <LaunchNav data-id="element-1072" />
      <HospitalityHero data-id="element-1073" />
      <PlatformOverview data-id="element-1074" />
      <LiveFloorPreview data-id="element-1075" />
      <AgentShowcase data-id="element-1076" />
      <AijentikBrain data-id="element-1077" />
      <EOIForm data-id="element-1078" />
      <FinalCTA data-id="element-1079" />

      {/* Minimal Footer */}
      <footer className="bg-[#050505] py-12 border-t border-white/5 text-center" data-id="element-1080">
        <p className="text-sm text-gray-500 font-medium tracking-widest uppercase mb-4" data-id="element-1081">
          Aijentik Hospitality
        </p>
        <p className="text-xs text-gray-600" data-id="element-1082">
          © {new Date().getFullYear()} Aijentik. All rights reserved.
        </p>
      </footer>

      {/* Mobile Sticky CTA */}
      <AnimatePresence data-id="element-1083">
        {showMobileCTA && <motion.div initial={{
        y: 100
      }} animate={{
        y: 0
      }} exit={{
        y: 100
      }} className="fixed bottom-0 left-0 right-0 p-4 bg-[#050505]/90 backdrop-blur-xl border-t border-white/10 z-50 md:hidden" data-id="element-1084">
            <button onClick={scrollToEOI} className="w-full bg-brand-orange text-white py-4 rounded-xl font-medium shadow-[0_0_20px_rgba(219,127,74,0.3)]" data-id="element-1085">
              Register Interest
            </button>
          </motion.div>}
      </AnimatePresence>
    </main>;
}